import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { UserAuthorizationType } from '@next-space/fe-api-idl';
import { useCallback } from 'react';
import { message } from 'src/common/components/message';
import { useOpenModal } from 'src/common/components/next-modal';
import { request } from 'src/common/request';
import { useFetchMe } from 'src/hooks/user/use-fetch-me';
import { $currentUserCache } from 'src/services/user/current-user';

const getMappingName = (t: any, type: UserAuthorizationType) => {
  const mappings = {
    [UserAuthorizationType.WECHAT]: t('common.wechat'),
    [UserAuthorizationType.QQ]: t('views.settings.unbind_account.qq'),
    [UserAuthorizationType.APPLE]: t('views.settings.unbind_account.apple'),
    [UserAuthorizationType.EMAIL]: t('common.email'),
    [UserAuthorizationType.PHONE]: t('common.phone'),
    [UserAuthorizationType.PASSWORD]: t('common.password'),
  };
  return mappings[type] || '';
};

export const useOpenUnbindDialog = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const fetchMe = useFetchMe();
  return useCallback(
    (type: UserAuthorizationType) => {
      openModal.warning({
        title: t('views.settings.unbind_account.title'),
        content: t('views.settings.unbind_account.content', { type: getMappingName(t, type) }),
        confirmText: t('views.settings.unbind_account.confirm'),
        confirm: async () => {
          await request.infra.unbindAccount($currentUserCache.uuid, {
            type,
          });
          await fetchMe();
          message.success(t('views.settings.unbind_account.unbind_success'));
        },
      });
    },
    [fetchMe, openModal, t]
  );
};
